function n(r) {
  if (r == null) return "";
  if (Array.isArray(r)) return r.map(n).join(",");
  var t = String(r);
  return t === "0" && Object.is(Number(r), -0) ? "-0" : t;
}
export { n as toString };